<template>
  <div class="active-main">
    <el-col class="active-col" :span="24">
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        label-position="top"
      >
        <el-row>
          <el-form-item label="活动名称" prop="subtitle">
            <el-input
              v-model.trim="formData.subtitle"
              placeholder="请输入活动名称"
              maxlength="20"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-row>
        <div class="choose-data">
          <el-form-item
            class="choose-data-item"
            label="打卡天数"
            prop="targetDays"
          >
            <el-input-number
              v-model="formData.targetDays"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item class="choose-data-item" label="活动类型" prop="type">
            <el-select v-model="formData.type" placeholder="活动类型">
              <el-option
                v-for="(v, k) in activeTypeList"
                :key="`pt_${k}`"
                :label="v"
                :value="k * 1"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="choose-data">
          <el-form-item
            class="choose-data-item"
            label="活动开始时间"
            prop="stime"
          >
            <el-date-picker
              v-model="formData.stime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              :picker-options="startPickerOptions"
              @change="startPikerOk"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            class="choose-data-item"
            label="活动结束时间"
            prop="etime"
          >
            <el-date-picker
              v-model="formData.etime"
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              :picker-options="endPickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="活动说明" prop="content">
          <el-input
            v-model.trim="formData.content"
            type="textarea"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 4 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动知晓书" prop="notice">
          <el-input
            v-model.trim="formData.notice"
            type="textarea"
            placeholder="请输入知晓书内容"
            maxlength="5000"
            show-word-limit
            :autosize="{ minRows: 15 }"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="活动规则"
          prop="ruleView"
          v-if="!!formData.rule.rules"
        >
          <div class="my-row">
            <div style="color: #606266">总打卡时间：</div>
            <div style="flex: 1">
              <el-time-picker
                v-model="formData.ruleView.clockTimes[1]"
                value-format="HH:mm:ss"
                placeholder="选择时间"
                size="mini"
                :clearable="false"
              >
              </el-time-picker>
            </div>
          </div>
          <div style="color: #606266">打卡任务：</div>
          <div
            class="my-row"
            style="margin-bottom: 10px; padding: 10px; border: 1px solid #eee"
            v-for="r in formData.ruleView.rules"
            :key="r.type"
          >
            <div>
              <div class="my-row">
                <div><el-checkbox v-model="r.selected"></el-checkbox></div>
                <div>
                  <div style="width: 90px">
                    <el-tag size="mini">{{ r.name }}</el-tag>
                  </div>
                </div>
              </div>
              <div
                class="my-row"
                v-if="
                  ['STEP', 'BP_MORNING', 'BP_EVENING', 'SLEEP'].includes(r.type)
                "
              >
                <div style="color: #606266">
                  {{ { STEP: "步数", SLEEP: "时长" }[r.type] || "次数" }}：
                </div>
                <div>
                  <el-input
                    size="mini"
                    v-model="r.num"
                    style="width: 66px"
                  ></el-input>
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div
                class="my-row"
                v-if="
                  ['STEP', 'BP_MORNING', 'BP_EVENING', 'SLEEP'].includes(r.type)
                "
              >
                <div style="color: #606266">统计时间：</div>
                <div style="flex: 1">
                  <el-time-picker
                    v-if="r.type !== 'SLEEP'"
                    is-range
                    v-model="r.dt"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    value-format="HH:mm:ss"
                    size="mini"
                    :clearable="false"
                    style="width: 100%"
                  >
                  </el-time-picker>
                  <el-row v-else>
                    <el-col :span="12">
                      <el-time-picker
                        class="s-picker"
                        v-model="r.dt[0]"
                        value-format="HH:mm:ss"
                        placeholder="开始时间"
                        size="mini"
                        :clearable="false"
                        style="text-align: center"
                      >
                      </el-time-picker>
                    </el-col>
                    <el-col :span="12">
                      <el-time-picker
                        class="s-picker"
                        v-model="r.dt[1]"
                        value-format="HH:mm:ss"
                        placeholder="结束时间"
                        size="mini"
                        :clearable="false"
                        prefix-icon="el-icon-minus"
                        style="text-align: center"
                      >
                      </el-time-picker
                    ></el-col>
                  </el-row>
                </div>
              </div>
              <div class="my-row">
                <div style="color: #606266">打卡时间：</div>
                <div style="flex: 1">
                  <el-time-picker
                    is-range
                    v-model="r.ct"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    value-format="HH:mm:ss"
                    size="mini"
                    :clearable="false"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- <div v-if="isEdit">
        <div style="padding-bottom: 16px">批量导入活动设备信息</div>
        <div class="active-dev-info">
          <div class="active-dev-all">
            <span>活动设备</span>
            <div class="active-dev-download" @click="downloadExcel">
              <img src="@/assets/images/download@2x.png" />
              下载全部活动设备
            </div>
          </div>
          <div class="active-dev-num">
            <span style="white-space: nowrap"
              >参加活动设备总数：<span
                class="dev-num-item"
                v-if="activeDevAll > 0"
                >{{ activeDevAll }}台</span
              ><span v-else>--</span></span
            >

            <div
              v-if="activeDevList && activeDevList.length > 0"
              style="display: flex; flex-wrap: wrap"
            >
              <div
                class="dev-num"
                v-for="(item, index) in activeDevList"
                :key="index"
              >
                <span>{{ item.code }}：</span
                ><span class="dev-num-item">{{ item.count }}台</span>
              </div>
            </div>
          </div>
        </div>
        <el-upload
          class="upload"
          accept=".xlsx"
          ref="uploadRef"
          drag
          action="#"
          :auto-upload="true"
          :http-request="upAndDowndoad"
          :before-upload="beforeUpload"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :show-file-list="false"
          :on-change="handleFileChange"
          :data="{
            promotionId: promotionId,
          }"
        >
          <div>
            <img
              v-if="uploadProgress !== 'finish'"
              class="el-upload-icon"
              src="@/assets/images/pic_excel@2x.png"
            />
            <img
              v-else
              class="el-upload-icon"
              src="@/assets/images/pic_excelupload@2x.png"
            />
            <div class="el-upload__text">
              将文件拖到此处，或<span v-if="uploadProgress === 'finish'"
                >继续</span
              ><em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传xlsx文件，请按照数据模板的格式准备导入数据，模板中的表头行不能删除
            </div>
          </div>
          <div v-if="false">
            <img
              class="el-upload-icon"
              src="@/assets/images/pic_excelupload@2x.png"
            />
            <div class="el-upload__text" @click.stop style="cursor: default">
              {{ fileName }}
            </div>
            <div
              class="el-upload__text"
              style="margin-top: 6px"
              @click="reUpload"
            >
              <em>重新上传</em>
            </div>
          </div>
        </el-upload>
        <div
          class="upload-prograss"
          v-if="uploadProgress !== 'finish' && fileName"
        >
          <div class="upload-prograss-top">
            <span class="file-name-space">
              <img
                style="width: 16px; height: auto; margin-right: 12px"
                src="@/assets/images/file@2x.png"
              />
              <span>{{ fileName }}</span></span
            >

            <el-progress
              v-if="uploadProgress === 'uploading'"
              class="progress-item"
              :stroke-width="4"
              color="#165DFF"
              :percentage="
                (
                  ((success_count + fail_count) / (totalDev || 1)) *
                  100
                ).toFixed(0) * 1
              "
            ></el-progress>
          </div>
          <div
            class="upload-prograss-text"
            v-if="uploadProgress === 'uploading'"
          >
            <span>正在导入数据，请勿关闭或刷新页面</span>
          </div>
        </div>
        <div
          v-else-if="uploadProgress === 'finish' && totalDev > 0"
          class="after-upload-info"
        >
          <div class="upload-num">
            <div class="upload-res" v-if="fail_count <= 0">
              <img
                style="width: 20px; height: auto"
                src="@/assets/images/check-circle-fill.png"
              />
              正常数量条数：{{ success_count }}条
            </div>
            <div v-else class="upload-res" style="background-color: #ffece8">
              <img src="@/assets/images/exclamation-circle-fill@2x.png" />
              正常数量条数：{{ success_count }}条，异常数量条数：<span
                style="color: #f77234"
                >{{ fail_count }}条</span
              >
            </div>
            <div
              v-if="this.file_url && fail_count > 0"
              class="download-imres"
              @click="downloadFail"
            >
              <img src="@/assets/images/download@2x.png" />
              下载导入结果
            </div>
          </div>
        </div>
        <div class="download-btn" v-if="uploadProgress === 'before'">
          <a
            :href="templateFileUrl"
            download="活动设备表（模板）.xlsx"
            class="a-btn"
          >
            <img src="@/assets/images/download@2x.png" />下载模版</a
          >
        </div>
      </div> -->
      <div class="save-space">
        <div class="save-btn" @click="saveActive">保存</div>
      </div>
    </el-col>
  </div>
</template>

<script>
import { API_URL } from "@/api/request";
import { activeImportDevice } from "@/api/device.js";
import { handleResponse } from "@/utils/response";
import { exportToExcel, activeTableDataTransform } from "@/utils/util";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    promotion: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      promotionId: "",
      uploadProgress: "before",
      fileList: [],
      templateFileUrl: "",
      totalDev: "", //本次上传设备总数
      success_count: "",
      fail_count: "",
      fileName: "",
      file_url: "",
      progressUuid: "",
      activeDevList: [],
      activeDevAll: 0, //参加活动的设备总数
      activeTypeList: {
        1: "再得一台",
        2: "退还全款",
        3: "全额奖励",
        4: "卖三赠一",
        5: "礼品奖励",
      },
      formData: {
        subtitle: "",
        stime: "",
        etime: "",
        content: "",
        targetDays: 21,
        type: 1,
        notice: "",
        rule: { rules: [] },
        ruleView: {
          clockTimes: ["00:00:00", "23:00:00"],
          rules: [
            {
              type: "SLEEP_MORNING",
              name: "晨起打卡",
              num: 1,
              dt: ["00:00:00", "23:00:00"],
              ct: ["08:00:00", "08:30:00"],
              selected: true,
            },
            {
              type: "BP_MORNING",
              name: "晨起血压测量",
              num: 1,
              dt: ["07:00:00", "10:00:00"],
              ct: ["10:00:00", "10:30:00"],
              selected: true,
            },
            {
              type: "STEP",
              name: "步数",
              num: 10000,
              dt: ["00:00:00", "22:00:00"],
              ct: ["22:00:00", "22:30:00"],
              selected: true,
            },
            {
              type: "BP_EVENING",
              name: "睡前血压测量",
              num: 1,
              dt: ["18:00:00", "21:00:00"],
              ct: ["21:00:00", "21:30:00"],
              selected: true,
            },
            {
              type: "SLEEP_EVENING",
              name: "早睡打卡",
              num: 1,
              dt: ["00:00:00", "23:00:00"],
              ct: ["20:00:00", "20:30:00"],
              selected: true,
            },
            {
              type: "SLEEP",
              name: "睡眠时长",
              num: 7,
              dt: ["20:00:00", "08:00:00"],
              ct: ["08:00:00", "08:30:00"],
              selected: false,
            },
            {
              type: "SHARE",
              name: "分享朋友圈",
              num: 1,
              dt: ["00:00:00", "23:59:59"],
              ct: ["00:00:00", "22:00:00"],
              selected: false,
            },
          ],
        },
      },
      startPickerOptions: {
        disabledDate: (time) => {
          const year2025 = new Date("2025-01-01 00:00:00").getTime();
          return time.getTime() < year2025;
        },
      },
      // 第二个选择器动态规则
      endPickerOptions: {
        disabledDate: (time) => {
          const year2025 = new Date("2025-01-01 00:00:00").getTime();
          const startTime = this.formData.stime
            ? new Date(this.formData.stime).getTime()
            : Infinity; // 未选时只限制2025年

          return (
            time.getTime() < year2025 || // 2025年前禁用
            time.getTime() < startTime // 早于开始日期禁用
          );
        },
      },
      rules: {
        subtitle: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            pattern: /^(?!\s)(?!.*\s$)[^\s]{1,20}$|^\S(?:[ \t]*\S){0,19}$/,
            message: "请输入20位以内的有效字符",
            trigger: ["blur", "change"],
          },
        ],
        stime: [{ required: true, message: "请输入开始日期", trigger: "blur" }],
        etime: [{ required: true, message: "请输入结束日期", trigger: "blur" }],
        targetDays: [
          { required: true, message: "请输入打卡天数", trigger: "blur" },
        ],
        notice: [
          { required: true, message: "请输入活动知晓书", trigger: "blur" },
        ],
        ruleView: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value?.clockTimes?.[1] &&
                value?.rules?.some((v) => v.selected)
              ) {
                return callback();
              } else {
                callback(new Error("请设置活动规则"));
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {
    this.templateFileUrl = API_URL + "/download/活动设备表（模板）.xlsx";
  },
  watch: {
    promotion(newVal, oldVal) {
      if (newVal.id) {
        const {
          id,
          subtitle,
          stime,
          etime,
          content,
          type,
          targetDays,
          notice,
          rule,
        } = newVal;
        this.promotionId = id;
        const { ruleView } = this.formData;
        if (rule.rules) {
          if (rule.clockTimes) {
            ruleView.clockTimes = [...(rule.clockTimes || [])];
          }
          ruleView.rules.forEach((r) => {
            const c = rule.rules.find((n) => n.type === r.type);
            if (c) {
              r.selected = true;
              r.num = c.num;
              r.dt = [...c.dt];
              r.ct = [...c.ct];
            } else {
              r.selected = false;
            }
          });
        }
        this.formData = {
          subtitle,
          stime,
          etime,
          content,
          type,
          targetDays,
          rule,
          ruleView,
          notice: (notice || "")
            .replaceAll("<br />\r\n", "\r\n")
            .replaceAll("<br/>\r\n", "\r\n")
            .replaceAll("<br/>", "\r\n")
            .replaceAll("<br />", "\r\n"),
        };
        // this.getActiveDev();
      }
    },
  },
  async mounted() {},
  methods: {
    // excel表格导出
    async downloadExcel() {
      if (this.activeDevAll <= 0) {
        this.$message.warning("暂无设备参加活动");
        return;
      }
      const { data } = await this.$get("/promotion/device/data", {
        id: this.promotionId,
        page: 1,
        size: 10000,
      });
      console.log("data23", data);

      this.totalTableData = data.data;
      this.totalTableData &&
        this.totalTableData.forEach(
          (item) => (item.status = item.status === 1 ? true : false)
        );

      const tableData = activeTableDataTransform(this.totalTableData);
      // console.log(tableData);
      exportToExcel(tableData, "example");
    },
    getActiveDev() {
      this.$get("/promotion/count/device", { id: this.promotionId }).then(
        (res) => {
          if (res.data?.code === 1000) {
            this.activeDevList = res.data?.data || [];
            if (this.activeDevList && this.activeDevList.length > 0) {
              let devAll = 0;
              this.activeDevList.forEach((r) => {
                devAll = devAll + r.count;
              });
              this.activeDevAll = devAll;
            }

            // this.activeDevList = [
            //   ...res.data?.data,
            //   ...res.data?.data,
            //   ...res.data?.data,
            // ];
          }
        }
      );
    },
    // getActiveInfo() {
    //   this.$get("/promotion/get", { id: this.promotionId }).then((res) => {
    //     if (res.data?.code === 1000) {
    //       const { subtitle, stime, etime, content } = res.data?.data || [];
    //       this.formData = {
    //         subtitle,
    //         stime,
    //         etime,
    //         content,
    //       };
    //     } else {
    //       this.$mesage.error(res.data?.msg);
    //     }
    //   });
    // },
    reUpload() {
      this.$refs.uploadRef.clearFiles(); // 清空文件列表
      this.totalDev = "";
      this.success_count = "";
      this.fail_count = "";
      this.fileName = "";
      this.uploadProgress = "before";
    },
    handleFileChange(flie) {
      this.fileName = flie.name;
    },
    // 下载失败数据
    downloadFail() {
      this.excelImportFlag = false;
      console.log("downloadFail", this.file_url);

      const fileURL = this.file_url;
      // 创建一个隐藏的链接
      const link = document.createElement("a");
      link.style.display = "none";
      document.body.appendChild(link);
      // 设置链接的 URL
      link.href = fileURL;
      // link.download = "file.xlsx";
      // 模拟点击链接以下载文件
      link.click();
      // 移除链接元素
      document.body.removeChild(link);
    },
    // 限制文件个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    getProgress() {
      console.log("this.progressUuid", this.progressUuid);
      if (!this.progressUuid) {
        return;
      }
      let form = new FormData();
      form.append("uuid", this.progressUuid);
      form.append("promotionId", this.promotionId);
      activeImportDevice(form).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.totalDev = data.total;
            this.success_count = data.success_count;
            this.fail_count = data.fail_count;
            if (data.file_url) {
              this.file_url = API_URL + data.file_url;
            } else {
              this.file_url = "";
            }
            if (data.status != 1) {
              setTimeout(() => {
                this.getProgress();
              }, 1000);
            } else {
              this.uploadProgress = "finish";
              if (this.totalDev <= 0) {
                this.$message.error("上传文件数据为空或模板错误");
              }
            }
          },
          (error) => {}
        );
      });
    },
    // 批量导入
    async upAndDowndoad(params) {
      console.log("params.file", params.file);
      let form = new FormData();
      form.append("file", params.file);
      form.append("uuid", this.progressUuid);
      form.append("promotionId", this.promotionId);
      const { data } = await activeImportDevice(form);
      console.log("data2", data);

      if (data.code === 1000) {
        this.totalDev = data.data.total;
        this.success_count = data.data.success_count;
        this.fail_count = data.data.fail_count;
        if (data.data.file_url) {
          this.file_url = API_URL + data.data.file_url;
        } else {
          this.file_url = "";
        }
        this.progressUuid = data.data.uuid;
        this.getProgress();
      } else {
        this.$message.error(data.msg);
      }
    },
    beforeUpload(file) {
      console.log("beforeUpload", file);
      if (!this.$jumpPerm("edit_activity")) {
        this.$message({
          type: "error",
          message: "没有权限",
        });
        this.fileName = "";
        return false;
      }
      if (this.uploadProgress === "uploading") {
        this.$message.warning("正在上传中，请稍后操作");
        return false;
      }
      // let legalName = ["xlsx", "xls"];
      let legalName = ["xlsx"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
        this.fileName = file.name;
        this.uploadProgress = "uploading";
      } else {
        this.$message.warning("文件格式不对，仅限xlsx");
        return false;
      }
    },
    startPikerOk() {
      if (this.formData?.etime) {
        const startTime = dayjs(this.formData.stime).valueOf();
        const endTime = dayjs(this.formData.etime).valueOf();
        if (startTime > endTime) {
          this.formData.etime = "";
        }
      }
    },
    saveActive() {
      if (this.isEdit && !this.$jumpPerm("edit_activity")) {
        this.$message({
          type: "error",
          message: "没有权限",
        });
        return;
      }
      if (!this.isEdit && !this.$jumpPerm("create_activity")) {
        this.$message({
          type: "error",
          message: "没有权限",
        });
        return;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          return false;
        }
      });
    },
    convertForm(data) {
      const { notice, ruleView, rule, ...other } = data;
      let newRule = rule;
      if (rule.rules) {
        newRule.clockTimes = ruleView.clockTimes;
        newRule.rules = ruleView.rules
          .filter((r) => r.selected)
          .map(({ selected, ...r }) => ({ ...r, num: r.num * 1 }));
      }
      return {
        ...other,
        rule: newRule,
        notice: notice
          .replaceAll("\r\n", "<RN/>")
          .replaceAll("\r", "<R/>")
          .replaceAll("\n", "<N/>")
          .replaceAll("<RN/>", "<br/>\r\n")
          .replaceAll("<R/>", "<br/>\r\n")
          .replaceAll("<N/>", "<br/>\r\n"),
      };
    },
    submitForm() {
      if (this.isEdit) {
        this.$post("/promotion/update", {
          ...this.convertForm(this.formData),
          id: this.promotionId,
        }).then((r) => {
          if (r.data.code === 1000) {
            // this.$refs.uploadRef.submit();
            this.$message.success("保存成功");
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          } else {
            this.$message.error(r.data.msg);
          }
        });
      } else {
        this.$post("/promotion/add", this.convertForm(this.formData)).then(
          (r) => {
            if (r.data.code === 1000) {
              this.$message.success("创建成功");
              setTimeout(() => {
                this.$router.back();
              }, 1500);
            } else {
              this.$message.error(r.data.msg);
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.active-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  // padding-top: 100px;
  box-sizing: border-box;
}
.app-right-main form {
  padding: 0 0px !important;
}
.choose-data {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.active-col {
  width: 50%;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-form-item {
  margin-bottom: 10px;
}
.choose-data-item {
  width: calc(50% - 10px);
}
.el-date-editor.el-input {
  width: 100%;
}
.save-space {
  margin-top: 20px;
}
.save-btn {
  width: 60px;
  height: 32px;
  background: #165dff;
  border-radius: 2px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.upload {
  width: 100%;
}
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
.download-btn {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  .a-btn {
    font-weight: 400;
    font-size: 14px;
    color: #165dff;
    display: flex;
    align-items: center;
  }
}
.after-upload-info {
  width: 100%;
}
.el-upload__tip {
  padding: 0 20px;
  box-sizing: border-box;
}
// .upload-num {
// }
.upload-prograss {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
}
.upload-prograss-top {
  background: #f7f8fa;
  display: flex;
  align-items: center;
  padding: 7px 7px 7px 12px;
  border-radius: 2px;
  box-sizing: border-box;
}
.el-upload-icon {
  width: 48px;
  height: 48px;
  margin-top: 40px;
}
.upload-res {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  box-sizing: border-box;
  background: #e8ffea;
  border-radius: 2px;
  img {
    width: 20px;
    height: auto;
    padding-right: 8px;
  }
}
.file-name-space {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
  display: flex;
  align-items: center;
}
.upload-prograss-text {
  font-weight: 400;
  font-size: 12px;
  color: #86909c;
  margin-top: 8px;
}
.progress-item {
  flex-grow: 1;
}
::v-deep .el-progress__text {
  margin-left: 20px;
}
::v-deep .el-progress-bar {
  padding-right: 40px;
  padding-left: 50%;
}
.download-imres {
  color: #165dff;
  cursor: pointer;
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
.active-dev-info {
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
  background-color: #f2f3f5;
  margin-bottom: 12px;
  .active-dev-all {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 8px;
    .active-dev-download {
      font-weight: 400;
      font-size: 14px;
      color: #165dff;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        margin: 0 8px 0 16px;
      }
    }
  }
  .active-dev-num {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    white-space: pre-wrap;
  }
  .dev-num {
    margin-left: 16px;
    white-space: nowrap;
  }
  .dev-num-item {
    color: #0fc6c2;
  }
}
::v-deep .s-picker .el-input__inner {
  text-align: center;
}
.my-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
</style>
